import React from 'react';
import styled from 'styled-components';

const ListContainer = styled.div`
  width: 300px;
  flex: none;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 8px;
  max-height: 600px;
  overflow-y: auto;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const ResetButton = styled.button`
  padding: 0.4rem 0.8rem;
  background-color: #ff4444;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s;

  &:hover {
    background-color: #cc0000;
  }
`;

const WinningItem = styled.div`
  background-color: white;
  padding: 0.75rem;
  margin: 0.4rem 0;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TimeStamp = styled.span`
  color: #666;
  font-size: 0.8rem;
`;

const Prize = styled.span`
  color: #2196F3;
  font-weight: bold;
  font-size: 0.9rem;
  margin-right: 0.5rem;
`;

const EmptyList = styled.div`
  text-align: center;
  padding: 2rem;
  color: #666;
`;

const WinningList = ({ winningHistory, onReset }) => {
    const handleReset = () => {
        if (window.confirm('Bạn có chắc chắn muốn xóa toàn bộ lịch sử?')) {
            onReset();
        }
    };

    return (
        <ListContainer>
            <HeaderContainer>
                <h2>Lịch sử trúng thưởng</h2>
                {winningHistory.length > 0 && (
                    <ResetButton onClick={handleReset}>
                        🗑️ Xóa
                    </ResetButton>
                )}
            </HeaderContainer>
            {winningHistory.length === 0 ? (
                <EmptyList>
                    <p>Chưa có kết quả nào</p>
                </EmptyList>
            ) : (
                winningHistory.map((item, index) => (
                    <WinningItem key={index}>
                        <Prize>{item.prize}</Prize>
                        <TimeStamp>{item.timestamp}</TimeStamp>
                    </WinningItem>
                ))
            )}
        </ListContainer>
    );
};

export default WinningList; 